<template>
  <client-only>
    <div class="careers-page text-dark bg-gray-350 pt-6 pb-10 md:pt-10 md:pb-16 md:py-10 px-4">
      <atoms-card
        class="
          max-w-[58rem] mx-auto !rounded-[1.25rem] !shadow-sm-3 py-4 px-4 lg:!p-10
          flex flex-col
        "
        shadow="lg"
        size="md"
      >
        <template v-if="!data.jobId">
          <div class="flex flex-col items-center gap-6 border-b-1 border-b-gray-400 pb-[1.984375rem] lg:items-start lg:flex-row lg:gap-10 lg:pb-[2.464375rem] mb-8 lg:mb-12">
            <div>
              <atoms-headline
                tag="h1"
                class="mb-6 text-2xl lg:text-[2rem] lg:leading-[2.5rem] lg:mb-9 font-bold row-start-1 col-start-1"
              >
                Careers
              </atoms-headline>

              <p class="row-start-2 row-end-3 col-start-1">
                Want to be part of a team that helps hundreds of households into a better financial future? We’re always on the lookout for new recruits to train up into experts.
              </p>
            </div>
            <div class="max-w-[25rem] w-full">
              <AtomsVideoFrame
                class="lg:col-start-2 lg:row-start-1 lg:row-end-3 mx-auto max-w-full"
                src="https://www.youtube.com/embed/atil8Ke80IA"
                width="400"
                height="226.48"
              />
            </div>
          </div>
        </template>

        <AtomsButtonBack
          v-else
          class="mb-10"
          @click="handleBack"
        />

        <div
          id="ja-jobs-widget"
          @click="handleRedirects"
        >
        </div>
      </atoms-card>
    </div>
  </client-only>
</template>

<script setup>
import { wait } from '@/helpers/functions'

const $route = useRoute()

const data = {
  jobId: null
}

defineOptions({
  name: 'Careers'
})

onMounted(() => {
  window._jaJobsSettings = {
    key: 'AU3_zsgy7jrt674uxc4haoj6fgiqfm',
    showLoadingImage: false,
    applicationFormSettings: {
      useExternalApplicationForm: true,
      showExternalApplicationFormInNewWindow: false
    }
  }

  const script = window.document.createElement('script')
  script.setAttribute('src', '//apps.jobadder.com/widgets/v1/jobs.min.js')
  script.setAttribute('async', true)
  window.document.body.appendChild(script)

  const query = $route.query
  data.jobId = query?.['ja-job'] ?? null
})

const handleRedirects = async $event => {
  await wait(300)

  const target = $event.target

  if (target.tagName !== 'A') {
    return
  }

  const dataset = { ...target.dataset }

  data.jobId = dataset.jobId
}

const handleBack = () => {
  const back = document.querySelector('.back-link')

  if (back) {
    back.click()
  }

  data.jobId = null
}

generateMeta({
  title: 'Careers & Jobs | Compare Club',
  ogTitle: 'Careers & Jobs | Compare Club',
  description: 'Want to help save Aussies money every day? View our latest career and job opportunities at Compare Club',
  ogDescription: 'Want to help save Aussies money every day? View our latest career and job opportunities at Compare Club',
  ogUrl: 'https://compareclub.com.au/careers/',
  ogImage: '',
  ogType: 'corporate'
}, pageIsFunnel($route))

</script>

<style
  lang="scss"
  src="./index.scss"
>
</style>
